import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	trigger: {
		alignItems: 'center',
		background: 'transparent',
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.text.light,
		cursor: 'pointer',
		display: 'inline-flex',
		flexShrink: 0,
		fontSize: THEME.typography.fontSizes.xs,
		gap: THEME.spacing.xs,
		opacity: 0,
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		transition: 'opacity 120ms ease-in-out',
		whiteSpace: 'nowrap',
		':hover': {
			background: THEME.colors.background.main,
			color: THEME.colors.text.main,
		},
	},
	triggerVisible: {
		opacity: 1,
	},
	chipWrapper: {
		alignItems: 'center',
		cursor: 'default',
		display: 'inline-flex',
	},
});
